import React from 'react';
import { motion } from 'framer-motion';
import { Check, X, ArrowRight } from 'lucide-react';
interface BenefitsProps {
  scrollToPricing: () => void;
}
export const Benefits: React.FC<BenefitsProps> = ({
  scrollToPricing
}) => {
  const rows = [{
    without: 'Improvisás las clases sin una estructura clara',
    with: 'Estructura de clases lista para dictar desde el día uno'
  }, {
    without: 'No sabés cuánto invertir ni qué equipamiento comprar',
    with: 'Sabés exactamente qué equipamiento comprar y cuánto invertir'
  }, {
    without: 'Lanzás sin estrategia y las clases quedan vacías',
    with: 'Estrategia de lanzamiento para llenar tus clases'
  }, {
    without: 'Cobrás sin saber si tu servicio es rentable',
    with: 'Números claros: precios, costos y punto de equilibrio'
  }, {
    without: 'Empezás todo desde cero, sola y a prueba y error',
    with: 'Material editable y bonos listos para usar'
  }];
  return <section className="py-16 bg-white" data-id="element-14">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-15">
        <div className="text-center mb-8" data-id="element-16">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3" data-id="element-17">
            La diferencia es clara
          </h2>
          <p className="text-base text-gray-600 max-w-xl mx-auto" data-id="element-18">
            Mirá cómo cambia el camino de tu estudio según la decisión que tomes
            hoy.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="rounded-2xl border border-barre-border shadow-md overflow-hidden" data-id="element-19">
          {/* Header */}
          <div className="grid grid-cols-2" data-id="element-20">
            <div className="bg-gray-100 text-gray-500 text-center py-3 px-3" data-id="element-21">
              <span className="text-sm sm:text-base font-bold" data-id="element-22">
                Sin Evoluciona
              </span>
            </div>
            <div className="bg-barre-pink text-white text-center py-3 px-3" data-id="element-23">
              <span className="text-sm sm:text-base font-bold" data-id="element-24">
                Con Evoluciona
              </span>
            </div>
          </div>

          {/* Rows */}
          {rows.map((row, index) => <div key={index} className={`grid grid-cols-2 ${index % 2 === 0 ? 'bg-white' : 'bg-barre-blush/30'}`} data-id="element-25">
              <div className="flex items-start gap-2 p-3 sm:p-4 border-r border-barre-border" data-id="element-26">
                <X className="w-4 h-4 text-gray-400 flex-shrink-0 mt-0.5" data-id="element-27" />
                <span className="text-xs sm:text-sm text-gray-500 font-medium" data-id="element-28">
                  {row.without}
                </span>
              </div>
              <div className="flex items-start gap-2 p-3 sm:p-4" data-id="element-29">
                <Check className="w-4 h-4 text-barre-pink flex-shrink-0 mt-0.5" data-id="element-30" />
                <span className="text-xs sm:text-sm text-gray-800 font-semibold" data-id="element-31">
                  {row.with}
                </span>
              </div>
            </div>)}
        </motion.div>

        <div className="mt-8 flex justify-center" data-id="element-32">
          <button onClick={scrollToPricing} className="bg-barre-pink hover:bg-barre-pinkHover text-white font-bold py-4 px-8 rounded-full shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1 flex items-center justify-center gap-2 text-lg" data-id="element-33">
            Quiero evolucionar
            <ArrowRight className="w-5 h-5" data-id="element-34" />
          </button>
        </div>
      </div>
    </section>;
};